/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : action-constants.ts
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali - H175591
 *
 * @Date         : Oct 10, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.
 *
 * By            : E807238
 * On            : Nov 1, 2019
 * Description   : ASDS-1673: Add To Cart Conformation UI & Integration
 *
 * By            : E844276
 * On            : Nov 18, 2019
 * Description   : Added generic product functionalities - removed from products
 *
 * By            : E807958
 * On            : Nov 21, 2019
 * Description   : ASDS-1801, ASDS-1802, ASDS-1803, ASDS-1804
 *
 * By           : H224423
 * On           : Nov 28, 2019
 * Description  : ASDS-1474 Accept product terms changes.
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1953
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1961 - loader/message while loading contract numbers in APU MSA flow
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 03 2019
 * Description   : ASDS-1964
 *
 * By            : Suresh Jaladi - E807958
 * On            : Dec 06, 2019
 * Description   : ASDS-1811
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Jan 9th, 2020
 * Description   : updated the code for ASDS-1081
 *
 * By            : Deepthi Bachu(E844276)
 * On            : Jan 28, 2020
 * Description   : ASDS-2048 - Admin Functionality
 *
 * By            : H224423
 * On            : Feb 26, 2019
 * Description   : ASDS-2349 - APU Product Features API Integration changes
 *
 * By            : Deepthi Bachu(E844276)
 * On            : Mar 13, 2020
 * Description   : ASDS-2414 - APU MSA - acknowledge after deleting product from cart for address change
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes.
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes. Changes to redirect user to default route.
 *
 * By            : H224423
 * On            : 10 Apr, 2020
 * Description   : ASDS-2497 - SIT Issue fixes. Contracts and sub-products API error handling.
 *
 * By             : H422337
 * On             : Sep 07,2020
 * Description    : ASDS-2570 UI enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 18,2020
 * Description    : ASDS-3025 UI enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 24,2020
 * Description    : ASDS-3026 APU enhancements as part of phase-2
 *
 * By            : H422336
 * On            : Sep 23, 2020
 * Description   : ASDS - 3020 - UI Enhancements for Phase - II
 *
 * By             : H422337
 * On             : Sep 25,2020
 * Description    : ASDS-3028 APU enhancements as part of phase-2
 *
 * By             : H422336
 * On             : Sep 29,2020
 * Description    : ASDS-3256 APU enhancements as part of phase-2
 *
 * By            : H422337
 * On            : Oct 08, 2020
 * Description   : ASDS - 3228 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct 13, 2020
 * Description   : ASDS - 3262, ASDS-3263 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct, 16 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II
 *
 * By            : H422336
 * On            : Oct, 22 2020
 * Description   : ASDS-3535 UI Enhancements for Phase-II
 *
 * By            : H422336
 * On            : Oct, 29 2020
 * Description   : ASDS-3793 UI Enhancements for Phase-II
 *
 * By            : H422336
 * On            : Nov, 5 2020
 * Description   : ASDS-4016 UI Enhancements for Phase-II
 *
 * By            : H422337
 * On            : Nov 04, 2020
 * Description   : ASDS-3265 - UI Enhancements for Phase - II -migrate to Forge API
 *
 ******************************************************************************/
const actions = {
  GET_CART_DETAILS: "getCartDetails",
  SET_CART_DETAILS: "setCartDetails",
  SET_PRODUCT_LISTING: "setProductListing",
  GET_PRODUCT_LISTING: "getProductListing",
  GET_CATEGORY_LISTING: "getCategoryListing",
  SET_CATEGORY_LISTING: "setCategoryListing",
  SET_SELECTED_CATEGORY: "setSelectedCategory",
  SET_PRODUCT_FEATURES: "setProductFeatures",
  SET_APU_PRODUCT_FEATURES: "setAPUProductFeatures",
  GET_PRODUCT_FEATURES: "getProductFeatures",
  SET_SELECTED_FEATURE: "setSelectedFeature",
  SET_SELECT_ACCOUNT: "setSelectAccount",
  RESET_SELECT_ACCOUNT: "resetSelectAccount",
  ADD_NEW_FEATURE: "addNewFeature",
  DELETE_FEATURE: "deleteFeature",
  UPDATE_FEATURE: "updateFeature",
  RESET_CONFIGURE_PRODUCT: "resetConfigureProducut",
  ADD_NEW_SERIAL: "addNewSerial",
  UPDATE_SERIAL_NUMBER: "updateSerialNumber",
  DELETE_SERIAL_NUMBER: "deleteSerialNumber",
  GO_TO_CONFIGURE_FEATURES: "gotoConfigureFeatures",
  GO_TO_CONFIRM_FEATURES: "gotoConfirmFeatures",
  SET_EXCEL_CONF_DATA: "setExcelConfData",
  GO_TO_BULK_CONFIRM_ORDER: "goToBulkConfirmOrder",
  SET_ADMIN_ACCOUNT_ADDRESSES: "setAdminAccountAddresses",
  BACK_BUTTON_HANDLE: "backButtonClicked",
  CONFIGURE_PRODUCT_MODEL: "openConfigurePropductModel",
  ADD_PRODUCT_TO_CART: "addProductToCart",
  GET_ABSTRACT_CART_VIEW: "getAbstractCartView",
  SET_ABSTRACT_CART_VIEW: "setAbstractCartView",
  GET_CUSTOMER_CBD_STATUS: "getCustomerCBDStatus",
  SET_CUSTOMER_PAYMENT_INFO: "setCustomerPaymentInfo",
  GET_ORDER_SUMMARY: "getOrderSummary",
  SET_ORDER_SUMMARY: "setOrderSummary",
  UPDATE_SEARCH_BY: "updateSearchBy",
  RESET_PLACE_ORDER_OBJ: "resetPlaceOrderObj",
  CHECK_FOR_PRICE_CHANGE: "checkForPriceChange",
  SET_TOASTER: "setToasterNotification",
  CHECK_FOR_PO_QUANTITY_IN_CART: "checkForPOQuantityInCart",

  VALIDATE_EMAIL_ADDRESS: "validateEmailAddress",
  ADD_UPDATE_EMAIL_ADDRESS: "addUpdateEmailAddress",
  SET_SELECTED_CART_LIST: "setSelectedCartList",
  GET_SELECTED_CART_LIST: "getSelectedCartList",
  LOAD_CART_DATA: "loadCartData",
  PLACE_ORDER_REQUEST: "placeOrderRequest",
  PLACE_ORDER_REQUEST_PROCESSING: "dispatchPlaceOrderProcessing",
  UPDATE_PAYMENT_MODE_CC_DATA: "updateCCPaymentData",
  UPDATE_CONTRACT_PURCHASE_DATA: "updateContractPurchaseData",
  GOTO_SERIAL_NUMBERS_TAB: "gotoSerialNumbersTab",
  GOTO_CONFIGURE_FEATURES_TAB: "gotoConfigureFeatuesTab",
  /** Constant to traverse to BUlk File upload tab */
  GOTO_BULK_FILE_UPLOAD_TAB: "gotoBulkFileUploadTab",
  /** Constant to traverse to tab 1 serial section from tab 2 (bulk upload confirm section) */
  GOTO_STEP1_SERIAL_NUMBERS_TAB: "gotoStep1SerialNumbersTab",
  /** Constant to traverse to tab 1 feature step from tab 2 (bulk upload confirm section) */
  GOTO_STEP1_CONFIGURE_FEATURES_TAB: "gotoStep1ConfigureFeatuesTab",
  SHOW_EDIT_MODEL: "cartEditModel",
  RESET_CONFIGURE_PRODUCT_MYCART: "resetMycartConfigureProducut",
  PRESET_CONFIGURE_PRODUCT_MYCART: "presetMycartConfigureProducut",
  UPDATE_IS_VALIDATING_FLAG: "updateIsValidatingFlag",
  ERROR_HANDLER: "errorHandler",
  SET_PRODUCT_LISTING_ERROR: "setProductListingError",
  SET_CATEGORY_LISTING_ERROR: "setCategoryListingError",
  SET_CART_POPUP_ERROR: "setCartPopupError",
  SAVE_CUSTOMER_TYPE: "saveCustomerType",
  CONFIGURE_PRODUCT_MAIN_TAB_CHANGE: "configureProductMainTabChange",
  VALIDATE_UPLOADED_BULK_CONFIG_FILE: "validateUploadedBulkConfigFile",
  GET_DEFAULT_EMAIL: "getDefaultEmaildId",
  TOGGLE_ENABLE_REVIEW_ORDER_BTN: "toggleEnableReviewOrderBtnStatus",
  UPDATE_PAYMENT_REQUIRED: "updatePaymentRequiredStatus",
  CLOSE_ASPIRE_MODEL: "closeAspireModel",
  DISPLAY_BULK_EXCEL_ERROR: "displayBulkError",
  UPDATE_CC_PAYMENT_FAILURE: "updaateCCpaymentFailure",
  SHOW_DELETE_MSG: "showProductDeleteMsg",
  CHECK_DELETE_PRODUCT_SUCCESS: "checkProductDeleted",
  TOGGLE_DELETE_POPUP: "toggleDeletePopUp",

  SET_ALERT_MODEL: "setAlertModel",
  SHOW_INCOMPATIBLE_TO_ADD_TO_CART: "inCompatilbleToAddToCart",
  CLOSE_PRODUCT_ALERT_MODAL: "closeinCompatibleProductsModal",
  SET_GENERIC_FIELDS: "setGenricFields",
  UPDATE_LAST_PROD_CART: "updateLastProductAddedToCart",
  ADD_PRODUCT_TO_CART_LOADER: "addProductToCartLoader",
  EDIT_PRODUCT_TO_CART_LOADER: "editProductToCartLoader",
  SHOW_INVALID_PRODUCT_TO_ADD_TO_CART: "invalidProductToAddToCart",
  CLOSE_INVALID_PRODUCT_TO_ADD_TO_CART: "closeInvalidProductToAddToCart",

  /* APU Configuration */
  APU_SAVE_CUSTOMER_TYPE: "saveApuCustomerType",
  APU_SAVE_CUSTOMER_ORDER_TYPE: "saveApuCustomerOrderType",
  APU_GOTO_SERIAL_CONFIG: "gotoConfigureApuSerials",
  APU_NONMSA_ADD_CONFIGURATION: "addNonMsaConfiguration",
  APU_NONMSA_DELETE_CONFIGURATION: "deleteNonMsaConfiguration",
  APU_NONMSA_SO_DELETE_CONFIGURATION: "deleteNonMsaSOConfiguration",
  APU_RESET_CONFIGURATION: "resetConfiguration",
  APU_GOTO_CUSTOMER_CATEGORY_TAB: "gotoCustomerCatergoryTab",
  APU_UPDATE_PURCHASE_TYPE: "updatePurchaseType",
  APU_UPDATE_AIRCRAFT_OEM: "apuUpdateAcOem",
  APU_UPDATE_SERIAL_NUMBER: "udpateApuSerialNumber",
  APU_GOTO_CONFIRM_CONFIG: "gotoConfirmConfig",
  APU_GOTO_CONFIGURE_TAB: "gotoProductConfigTab",
  APU_BACK_BUTTON_HANDLE: "apuBackButtonClicked",
  APU_CONFIGURE_PRODUCT_MODEL: "onClickAPUConfigureButton",
  APU_UPDATE_SERIAL_NUMBER_MSA: "updateMSASerial",
  APU_UPDATE_AIRCRAFT_OEM_MSA: "updateAircraftOEMMSA",
  APU_UPDATE_SOLD_TO_MSA: "updateAPUSoldTo",
  APU_MSA_ADD_CONFIGURATION: "addMsaConfiguration",
  APU_MSA_DELETE_CONFIGURATION: "deleteMsaConfiguration",
  GOTO_PRODUCT_CONFIGURE_TAB: "gotoProductConfigureTab",
  ADD_APU_PRODUCT_TO_CART: "addAPUProductToCart",
  SHOW_EDIT_MODEL_APU: "cartAPUEditModel",
  HIDE_EDIT_MODEL_APU: "hideAPUEditModel",
  PRESET_CONFIGURE_APU_MYCART: "presetMycartConfigureAPU",
  ADD_CONTRACT_DATA: "addContractData",
  CLOSE_APU_MODEL: "closeApuModel",
  UPDATE_APU_ACCEPT_TERMS_STATUS: "updateAPUAcceptTermsStatus",
  UPDATE_WIRELESS_ACCEPT_TERMS_STATUS: "updateWirelessAcceptTermsStatus",
  SET_CONTRACTS_LOADING: "setContractsProductsLoading",
  SET_SUB_PRODUCTS_LOADING: "setSubProductsLoading",
  UPDATE_EXPIRED_CONTRACTS_RESPONSE: "updateExpiredContractResponse",

  SHOW_ERROR_ON_DELETE_PROD: "showErrorOnDeleteProduct",
  HIDE_ERROR_ON_DELETE_PROD: "hideErrorOnDeleteProduct",
  SET_ERROR_ON_EDIT_PROD: "setErrorOnEditProduct",
  WIRELESS_ADD_TO_CART_MODEL: "onClickWirelessAddToCartButton",
  WIRELESS_RESET_CONFIGURATION: "resetWirelessConfiguration",
  WIRELESS_GOTO_CONFIRM_CONFIG: "gotoWirelessConfirmConfig",
  WIRELESS_BACK_BUTTON_HANDLE: "wirelessBackButtonHandle",
  WIRELESS_ADD_AIRCRAFT: "addWirelessAircraft",
  WIRELESS_DELETE_AIRCRAFT: "deleteWirelessAircraft",
  WIRELESS_UPDATE_AIRCRAFT_TYPE: "updateWirelessAircraftType",
  WIRELESS_UPDATE_AIRCRAFT_SERIAL: "updateWirelessAircraftSerial",
  WIRELESS_UPDATE_AIRCRAFT_TAIL: "updateWirelessAircraftTail",
  WIRELESS_AIRCRAFT_TYPE_PROCESSING: "dispatchAircraftTypeInfoProcessing",
  SHOW_EDIT_MODEL_WIRELESS: "cartWirelessEditModel",
  HIDE_EDIT_MODEL_WIRELESS: "hideWirelessEditModel",
  PRESET_CONFIGURE_WIRELESS_MYCART: "presetMycartConfigureWireless",
  ADD_WIRELESS_PRODUCT_TO_CART: "addWirelessProductToCart",
  CLOSE_WIRELESS_MODEL: "closeWirelessModel",
  GET_WIRELESS_AIRCRAFT_TYPE: "getAircraftTypes",
  HIDE_VALIDATION_ERROR_MSG: "hideValidationErrorMsg",
  GET_PURCHASEORDER_DETAILS: "getPurchaseOrderDetails",
  APU_UPDATE_CUSTOMER_PO_NONMSA: "updatePurchaseOrderNumber",

  SET_SELECT_ACCOUNT_DETAILS_IN_USER_VALIDATION_DATA:
    "set_select_account_details_in_user_validation_data",

  SHOW_FEATURE_NOTIFICATION: "showFeatureNotification",
  MSA_SUCCESS_FLAG: "updatedeleteAllProductsSuccessFlag",
  NON_MSA_PO_SUCCESS_FLAG: "updateDeleteNonMSAPOSuccessFlag",
  RESET_SHIPPING_BILLING_DATA: "resetShippingBillingData",
  APU_UPDATE_NON_MSA_SO_SERIAL_NUMBER: "apuUpdateNonMsaSOSerialNumber",
  APU_UPDATE_NON_MSA_SO_NUMBER: "apuUpdateNonMsaServiceOrderNumber",
  APU_NONMSA_SO_ADD_CONFIGURATION: "apuNonMsaServiceOrderAdd",
  APU_NONMSA_SO_ADD_ERROR_DATA: "apuNonMsaServiceOrderAddErrorData",
  APU_NONMSA_SO_VALIDATE_API_ERROR: "apuNonMsaSOvalidateApiError",
  APU_NONMSA_KEY_ONLY_UPDATE_SERIAL_NUMBER:
    "updateApuNonMsaKeyOnlySerialNumber",
  APU_NONMSA_KEY_ONLY_ADD_CONFIGURATION: "addApuNonMsaKeyOnlyConfiguration",
  APU_NONMSA_KEY_ONLY_DELETE_CONFIGURATION:
    "deleteApuNonMsaKeyOnlyConfiguration",
  OPEN_CART_ICON: "openCartIcon",

  /* Order History */
  GET_ORDER_HISTORY: "getOrderHistory",
  PROCESSING_ORDER_REQUEST: "processingRequest",
  SET_SOLD_TO_OPTIONS: "setSoldToOptions",
  UPDATE_ORDER_FILTERS: "updateFilters",

  // Apply Coupon
  CHECK_COUPON_DATA: "CHECK_COUPON_DATA",
  GET_COUPON_DATA: "GET_COUPON_DATA",
  SET_COUPON_DATA:"SET_COUPON_DATA",
  // Cart List
  GET_DISCOUNT_AMOUNT: "GET_DISCOUNT_AMOUNT",
  GET_MODEL_NAME: "GET_MODEL_NAME",
  GET_MODEL_B_NAME: "GET_MODEL_B_NAME",
  // Review Order
  SHOW_REVIEW_ORDER: "SHOW_REVIEW_ORDER",
  APU_ORDER_DATA: "APU_ORDER_DATA"
};

export default actions;
